import React, { ElementType, ReactNode } from 'react';
import styles from './Carousel.module.scss';
import Box from '@/components/UI/box/Box';
import { Splide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
interface CarouselProps {
  opts?: any;
  sliderClassName?: string;
  children: ReactNode;
  component?: ElementType;
}
const Carousel: React.FC<CarouselProps> = props => {
  const {
    opts,
    children,
    sliderClassName = 'default-carousel-wrapper',
    ...rest
  } = props;
  const settings = React.useMemo(() => {
    return {
      direction: 'rtl',
      lazyLoad: 'nearby',
      ...opts
    };
  }, [opts]);
  return <Box component={props.component} className={`${styles['styles-carousel']}`} data-sentry-element="Box" data-sentry-component="Carousel" data-sentry-source-file="Carousel.tsx">
      <Splide className={sliderClassName} options={settings} {...rest} data-sentry-element="Splide" data-sentry-source-file="Carousel.tsx">
        {children}
      </Splide>
    </Box>;
};
export default Carousel;